import React, {useEffect, useState} from "react";
import "./MilenaPage.scss";

const CORRECT_PASSWORD = "iloveyoubaby";

export default function MilenaPage() {
  const [input, setInput] = useState("");
  const [phase, setPhase] = useState("password"); // "password" | "greeting"
  const [error, setError] = useState(false);

  useEffect(() => {
    if (phase === "greeting") {
      const timer = setTimeout(() => {
        window.location.replace("/study-cards.html");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [phase]);

  const handleSubmit = e => {
    e.preventDefault();
    if (input === CORRECT_PASSWORD) {
      setPhase("greeting");
    } else {
      setError(true);
    }
  };

  if (phase === "greeting") {
    return (
      <div className="milena-unlocked">
        <div className="milena-heart">❤️</div>
        <h1>Hi Milena</h1>
        <p>This page was made just for you.</p>
      </div>
    );
  }

  return (
    <div className="milena-container">
      <div className="milena-card">
        <h1>Private Page</h1>
        <p>Enter the password to continue.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            className={`milena-input${error ? " milena-input--error" : ""}`}
            placeholder="Password"
            value={input}
            onChange={e => {
              setInput(e.target.value);
              setError(false);
            }}
            autoFocus
          />
          {error && <p className="milena-error">Wrong password, try again.</p>}
          <button type="submit" className="milena-btn">
            Enter
          </button>
        </form>
      </div>
    </div>
  );
}
